<template>

    <transition name="fade-transition">
        <v-container wrap row fill-height class="popup-station-overlay">

            <v-layout align-center>
                <v-flex xs12 class="popup">
                    <div class="background"></div>
                    <v-container fill-height class="data-display">
                        <v-layout fill-height row wrap>
                            <v-flex xs12 grow align-self-start
                                    class="data-content">
                                <slot></slot>
                            </v-flex>
                            <v-flex xs12 align-self-end class="button-area">
                                <v-layout justify-center fill-height row wrap>
                                    <v-flex text-xs-left xs12 align-self-end>
                                        <v-btn class="close" @click="close()">
                                            {{$vuetify.t("$vuetify.BasePopUp.close")}}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>

        </v-container>
    </transition>


</template>

<script>

    export default {
        methods: {
            close() {
                this.$emit("close")
            }
        }
    }


</script>

<style lang="scss" scoped>

    .popup-station-overlay {
        position: fixed;
        padding: 32px;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9999;
        max-width: none;


        .popup {
            height: 458px;
            position: relative;
            color: var(--v-primary-base);


            .background {
                position: absolute;
                height: 100%;
                width: 100%;
                opacity: 0.88;
                background-color: var(--v-menubackground-base);
            }

            .data-display {
                position: relative;
                text-align: left;


                .data-content {
                    height: calc(100% - 30px);
                }

                .button-area {
                    height: 30px;

                    .close {
                        background-color: transparent;
                        margin: auto;
                        box-shadow: none;
                        will-change: unset;
                        padding: 0;
                        height: auto;
                        min-width: unset;

                        & /deep/ .v-btn__content {
                            color: var(--v-primary-base);
                            font-size: 15px
                        }
                    }
                }
            }
        }
    }


</style>